import { Longform } from "@anthra/ui/typography"
import { createFileRoute } from "@tanstack/react-router"

import { Points, ProsePage, Section } from "@/components/prose-page"

/**
 * Terms of service.
 *
 * DRAFTED FROM WHAT THE PRODUCT DOES, NOT FROM A TEMPLATE. Every clause here
 * describes behaviour that exists in this codebase: OTP sign-in, 5-day
 * sessions, three attachments, expert review, auto-close, no payment path.
 *
 * IT HAS NOT BEEN THROUGH A LAWYER. This is honest, specific text that says
 * what the service actually is, which is the right starting point — but the
 * liability, governing-law and termination clauses in particular need a
 * practitioner's eye before this is relied on. Flagged to the client rather
 * than presented as settled.
 */
export const Route = createFileRoute("/terms")({ component: Terms })

function Terms() {
	return (
		<ProsePage
			title="Terms of service"
			updated="2026-08-25"
			intro="These terms cover your use of Swamithra Tax KPO Private
Limited’s online service. Using the service means you accept them."
		>
			<Section title="What we do">
				<Longform>
					Swamithra connects Individual Taxpayers and Professionals with a panel of former
					Indian Revenue Service (IRS) officers to answer your Income Tax queries, and
					review your draft response before you file it.
				</Longform>
			</Section>

			<Section title="What we do not do">
				<Points
					items={[
						"We do not file returns or replies on your behalf.",
						"We do not represent you before the Income-tax Department.",

						"An answer is professional guidance on the material you send us. It is not a substitute for a formal opinion where one is required.",
					]}
				/>
			</Section>

			<Section title="Your account">
				<Points
					items={[
						"You sign in with a WhatsApp number and a OTP. There is no password.",
						"A session stays open for 24 hours of inactivity.",
						"A OTP reaches you on WhatsApp only, and it works for 10 minutes.",
						"Nobody from Swamithra will ever ask you to read an OTP out. Treat anyone who does as an impostor.",
					]}
				/>
			</Section>

			<Section title="What you send us">
				<Points
					items={[
						"You confirm you are entitled to share the documents you upload.",
						"Answers rest on what you send. Incomplete or altered documents produce answers that do not hold.",
						"A question cannot be edited once sent. Add corrections as a follow-up in the same thread.",
						"A closed question cannot be reopened. Start a new one.",
					]}
				/>
			</Section>

			<Section title="Professionals acting for clients">
				<Longform>
					If you are a professional acting on behalf of your client, queries you raise for
					your clients sit under your account, and you are responsible for having their
					permission to share their documents with us.
				</Longform>
			</Section>

			<Section title="Availability">
				<Longform>
					We aim to keep the service running and to reply promptly, but we do not
					guarantee uninterrupted access or a fixed response time.
				</Longform>
			</Section>

			<Section title="Ending your use">
				<Longform>
					You may stop using the service at any time and ask us to close your account. We
					may suspend an account that is used to abuse the service.
				</Longform>
			</Section>

			<Section title="Changes to these terms">
				<Longform>
					If these terms change materially we will say so in the app before the change
					takes effect. The date above is when this text last changed.
				</Longform>
			</Section>

			<Section title="Contact">
				<Longform>
					Swamithra Tax KPO Private Limited, Hyderabad. Questions about these terms go to
					help@swamithra.com.
				</Longform>
			</Section>
		</ProsePage>
	)
}
